import { createApp } from "vue";
//도메인에 따라 App, store, router 를 나누어서 보여지도록 처리한다.

import defaultWebRouter from "@/router";
import defaultWebApp from "@/App.vue";
import defaultWebStore from "@/store";
import { initSiteSeo } from "@/utils/seo";

import VueTailwindDatepicker from "vue-tailwind-datepicker";
import tracker from "@/plugins/openReplay.js";
import { startSessionReplay } from "@/plugins/sessionReplay.js";

let App, store, router;

App = defaultWebApp;
store = defaultWebStore;
router = defaultWebRouter;

// idx 없이도 노출하는 예외 경로 (이 경우 idx=1 + 상단 헤더 숨김)
const RENDER_WITHOUT_IDX = ["/courseIntroduce", "/enrolment/step", "/learningSupport/faq"];

// idx 를 못 구했을 때: 예외 경로는 idx=1 + 헤더 숨김으로 노출, 그 외는 내부 404(/notFound)로 이동
const handleMissingIdx = () => {
  // 새로고침 등으로 SEO·URL 에 idx 가 없어도, 영속(persist)된 store 값이 있으면 그대로 유지 (404 리다이렉트 방지)
  if (store.getters.getIdxLeSiteMain) {
    return;
  }
  const pathname = location.pathname;
  if (RENDER_WITHOUT_IDX.some((p) => pathname.startsWith(p))) {
    store.commit("setIdxLeSiteMain", 1);
    store.commit("setHideHeader", true);
  } else if (pathname !== "/notFound") {
    location.replace(`${location.origin}/notFound`);
  }
};

// idx 확정 후 주소창에서 idxLeSiteMain 쿼리만 제거 (값은 store 에 있으므로 기능 유지, 사용자에게 노출 안 함).
// 라우터가 초기 URL 을 복원하지 않도록 mount 이후 router.replace 로 처리. 다른 쿼리·hash 는 보존.
const stripIdxFromUrl = () => {
  const cur = router.currentRoute.value;
  if (cur.query.idxLeSiteMain === undefined) {
    return;
  }
  const query = { ...cur.query };
  delete query.idxLeSiteMain;
  router.replace({ path: cur.path, query, hash: cur.hash });
};

// 헤더 숨김 플래그는 매 진입마다 초기화 (예외 경로에서만 다시 켠다)
store.commit("setHideHeader", false);

// 도메인 기준으로 SEO + idxLeSiteMain 조회 (항상 최신값으로 갱신)
try {
  const seoData = await initSiteSeo();

  // idxLeSiteMain 확정: SEO 우선, 없으면 URL 파라미터 또는 index.html 이 보관한 값으로 폴백 (개발/테스트용)
  let idxLeSiteMain = seoData?.idxLeSiteMain;
  if (idxLeSiteMain) {
    store.commit("setIdxLeSiteMain", idxLeSiteMain);
  } else {
    idxLeSiteMain = new URL(location.href).searchParams.get("idxLeSiteMain") || window.__LIFEEDU_IDX__ || null;
    if (idxLeSiteMain) {
      store.commit("setIdxLeSiteMain", idxLeSiteMain);
    } else {
      handleMissingIdx();
    }
  }
} catch (error) {
  console.error("[main] SEO 초기화 중 예외 발생, idx 처리합니다.", error);
  handleMissingIdx();
}

const app = createApp(App).use(router).use(store).use(VueTailwindDatepicker);

app.config.globalProperties.$openReplay = tracker;
tracker.start();
startSessionReplay();

app.mount("#app");

// 라우터 준비 후 주소창에서 idxLeSiteMain 노출 제거 (idx 는 이미 store 에 있음).
router.isReady().then(() => {
  if (store.getters.getIdxLeSiteMain) {
    stripIdxFromUrl();
  }
});
